'use client'

import type { HTMLAttributes, ReactNode } from 'react'
import { useNavigationPrototypeOptional } from '@/components/layout/navigation-prototype-context'

interface WorkspacePageContentHeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode
}

/**
 * Preserves the legacy page-owned H1 while yielding document-level hierarchy to
 * the navigation prototype's shared global title row.
 */
export function WorkspacePageContentHeading({
  children,
  ...props
}: WorkspacePageContentHeadingProps) {
  const navigationPrototype = useNavigationPrototypeOptional()

  return navigationPrototype?.enabled ? (
    <h2 {...props}>{children}</h2>
  ) : (
    <h1 {...props}>{children}</h1>
  )
}
